import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    filter: "grayscale(67%)",
    height: "100%",
  },
  st0: {
    fill: "#707372",
  },
  st1: {
    fill: "#7AC143",
  },
}));

export const OfqualLogo = () => {
  const classes = useStyles();

  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 692.3 236.6"
      enableBackground="new 0 0 692.3 236.6"
      className={classes.root}
    >
      <g id="Logo_3c">
        <g>
          <path
            className={classes.st0}
            d="M351.7,236.6c-10.8,0-21.5,0-32.3,0c0-21.4,0-42.7,0-64.4c-0.8,0.9-1.4,1.5-2,2.1
			c-7.2,8.2-16.2,13.2-27.1,14.3c-17.5,1.8-32.9-3.1-45.7-15.4c-10-9.7-15.7-21.7-18.4-35.2c-3.4-16.5-2.5-32.8,3.2-48.8
			c3.7-10.2,9.2-19.1,17.4-26.3c9.5-8.4,20.7-12.9,33.3-13.5c7.8-0.4,15.4,0.4,22.6,3.8c6,2.8,11.1,6.7,15.5,11.7
			c0.3,0.4,0.7,0.7,1.2,1.2c0-4.8,0-9.3,0-14c10.9,0,21.6,0,32.4,0C351.7,113.6,351.7,175.1,351.7,236.6z M320.3,119.1
			c0-4.6,0.1-9.2,0-13.8c-0.2-8.6-3.8-15.7-10.9-20.7c-6.2-4.4-13.2-5.8-20.7-5.5c-12.6,0.6-21.8,6.7-26.7,18.2
			c-6,13.8-5.9,28.1-0.7,42.2c3,8.1,8.6,14.1,16.7,17.3c6.6,2.6,13.4,2.9,20.3,1.5c13.7-2.8,22.3-13.6,22-26.7
			C320.3,127.5,320.3,123.3,320.3,119.1z"
          />
          <path
            className={classes.st0}
            d="M0,119.1c0-14,3-27.3,10.3-39.4c10.1-16.7,25-26.5,44.2-29.6c12.2-2,24.2-1.1,35.8,3.3
			c18.7,7.2,30.9,20.7,37.5,39.5c3.9,11.1,4.9,22.5,3.9,34.2c-1.1,12.3-4.7,23.8-11.7,34.1c-9.8,14.4-23.3,23.2-40.4,26.5
			c-13.6,2.6-26.9,1.7-39.8-3.7c-17.3-7.3-28.9-20.1-35.3-37.7c-2.8-7.6-4.2-15.6-4.5-23.7C0,121.5,0,120.3,0,119.1z M98.9,118.5
			c0-4.2-0.4-9-1.6-13.6c-1.7-6.9-4.7-13.2-10.1-18c-8.3-7.5-18.2-9.1-28.8-7c-10.8,2.2-17.9,9.2-21.8,19.3
			c-4.3,11.2-4.4,22.8-1.8,34.4c1.6,6.8,4.7,12.8,9.9,17.6c5.2,4.8,11.4,7.2,18.4,7.8c14.1,1.1,25.7-5.3,31.5-18
			C97.9,134.1,98.9,126.7,98.9,118.5z"
          />
          <path
            className={classes.st1}
            d="M692.3,204.4c0,10.8,0,21.4,0,32.2c-107.5,0-215,0-322.5,0c0-10.7,0-21.4,0-32.2
			C477.3,204.4,584.7,204.4,692.3,204.4z"
          />
          <path
            className={classes.st0}
            d="M623.3,165.8c-1.6,2.5-3.1,5-4.7,7.5c-3.1,4.9-6.2,9.7-9.2,14.6c-0.4,0.7-0.9,0.9-1.7,0.8
			c-9.7-1.2-17.1-6.1-22.2-14.5c-0.4-0.6-0.7-1.2-0.9-1.4c-1.6,1.4-3.2,2.8-4.7,4.2c-7.4,7.2-16.4,10.7-26.6,11.7
			c-9.9,0.9-19.4-0.5-28.3-5.1c-10.9-5.6-18.8-14-22-26.1c-3.2-12.3-1.5-24,6.7-34.2c5.5-6.7,12.7-10.8,21-12.9
			c5.2-1.3,10.6-2.1,15.9-2.9c11-1.7,22-3.2,33-4.8c1.1-10.1-2.1-20.6-13.8-24c-7.6-2.2-15.3-1.9-23-0.2c-8.5,1.9-16.6,4.7-24.3,8.6
			c-0.3,0.2-0.7,0.3-1.2,0.5c-4.2-8.1-8.3-16.2-12.5-24.4c1.8-0.9,3.5-1.8,5.3-2.6c10.4-4.8,21.1-8.5,32.5-10.2
			c13.3-2.1,26.6-1.9,39.7,1.8c12.1,3.5,21.3,10.8,26.5,22.5c2.5,5.6,3.4,11.6,3.4,17.7c0.1,19.5,0.1,39,0.1,58.4
			c0,5.3,1.9,9.4,6.5,12.1C620.3,164,621.8,164.9,623.3,165.8z M579.9,125.9c-0.3,0-0.4,0-0.6,0c-8,1.4-16,2.7-24,4.1
			c-3.5,0.6-7.1,1-10.4,2.6c-3.5,1.7-6.5,4-8,7.7c-3.6,8.8,1.3,19.1,10.5,22.4c4.5,1.6,9.2,1.7,13.8,1.1
			c10.1-1.3,17.7-9.1,18.3-19.2c0.3-5.3,0.2-10.5,0.2-15.8C579.9,127.7,579.9,126.8,579.9,125.9z"
          />
          <path
            className={classes.st0}
            d="M369.7,52.1c10.8,0,21.5,0,32.4,0c0,0.6,0,1.1,0,1.6c0,25.9,0,51.8,0,77.7c0,4.8,0.6,9.6,2.4,14.1
			c2.9,7.2,8.2,11.5,15.8,12.7c8,1.3,15.5-0.2,21.8-5.5c4.9-4.1,7.6-9.6,8.9-15.8c0.7-3.5,1.2-7.2,1.2-10.8
			c0.1-24.1,0.1-48.2,0.1-72.3c0-0.5,0-1,0-1.6c10.8,0,21.5,0,32.2,0c0,44.7,0,89.4,0,134.2c-10.7,0-21.4,0-32.2,0c0-4.5,0-9,0-13.8
			c-1,0.9-1.8,1.7-2.6,2.4c-5.8,5.6-12.2,10.2-20.1,12.2c-14.5,3.6-28.4,2.5-41.2-5.9c-9.9-6.5-15.5-16-17.7-27.4
			c-0.7-3.7-1-7.5-1-11.3c-0.1-29.6,0-59.3,0-88.9C369.7,53.1,369.7,52.6,369.7,52.1z"
          />
          <path
            className={classes.st1}
            d="M0,204.4c100.5,0,200.8,0,301.3,0c0,10.8,0,21.4,0,32.2c-100.5,0-200.8,0-301.3,0C0,225.9,0,215.2,0,204.4z"
          />
          <path
            className={classes.st0}
            d="M193.2,52c8.8,0,17.4,0,26.1,0c0,9.2,0,18.4,0,27.7c-8.7,0-17.4,0-26.2,0c0,35.6,0,71,0,106.6
			c-10.8,0-21.6,0-32.4,0c0-35.5,0-71,0-106.6c-7.3,0-14.5,0-21.8,0c0-9.3,0-18.4,0-27.7c7.2,0,14.4,0,21.8,0c0-0.6,0-1.1,0-1.6
			c0-6.4-0.1-12.8,0.1-19.2c0.2-7.8,2.7-14.7,8.2-20.4c4.5-4.6,10-7.3,16.2-8.9c7-1.8,14.2-2.1,21.4-1.7c6.5,0.4,13.1,1,19.6,1.5
			c0.3,0,0.6,0.1,1,0.2c-0.9,8.9-1.7,17.8-2.6,26.9c-1.3-0.1-2.5-0.3-3.8-0.4c-5.5-0.5-10.9-1-16.4-0.4c-4.4,0.5-8.2,2.2-10.1,6.4
			c-0.7,1.4-1,3.1-1.1,4.7c-0.2,4-0.1,8-0.1,12C193.1,51.5,193.2,51.7,193.2,52z"
          />
          <path
            className={classes.st0}
            d="M637.3,5.4c10.8,0,21.5,0,32.4,0c0,0.5,0,1,0,1.5c0,47.8,0,95.7,0,143.5c0,1.6,0.3,3.3,0.9,4.8
			c1.5,3.9,4.9,5.4,8.8,5.6c3,0.1,6-0.3,8.9-0.5c0.4,0,0.8-0.1,1.3-0.2c0.8,9,1.7,18,2.5,27c-2.1,0.3-4.1,0.7-6.1,0.8
			c-6.4,0.4-12.8,0.8-19.1,1c-4.9,0.1-9.7-0.9-14.2-2.9c-8.6-3.7-13.4-10.4-14.9-19.6c-0.4-2.3-0.5-4.7-0.5-7
			c0-50.8,0-101.6,0-152.4C637.3,6.5,637.3,6,637.3,5.4z"
          />
        </g>
      </g>
    </svg>
  );
};
